// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  .upselling-screen .screen-filters button {
    width: 100%;
  }
}
.upselling-screen-current h4 {
  font-size: 18px;
  color: var(--black9);
  padding: 0;
  margin: 0;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 1.5rem;
}

.upselling-table-type {
  display: flex;
}
.upselling-table-type-icon {
  background: var(--black2);
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upselling-table-type-image {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  object-fit: cover;
}
.upselling-table-type-date {
  font-size: 12px;
  color: var(--black4);
}
.upselling-table-type-title {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/upselling/style.scss"],"names":[],"mappings":"AAEE;EAEI;IACE,WAAA;EAFN;AACF;AAQI;EACE,eAAA;EACA,oBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AANN;;AAYA;EACE,aAAA;AATF;AAWE;EACE,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATJ;AAYE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAVJ;AAaE;EACE,eAAA;EACA,oBAAA;AAXJ;AAcE;EACE,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;AAZJ","sourcesContent":[".upselling-screen {\n\n  @media (max-width: 768px) {\n    .screen-filters {\n      button {\n        width: 100%;\n      }\n    }\n  }\n\n  &-current {\n\n    h4 {\n      font-size: 18px;\n      color: var(--black9);\n      padding: 0;\n      margin: 0;\n      font-weight: 500;\n      line-height: 1.2;\n      margin-bottom: 1.5rem;\n    }\n\n  }\n}\n\n.upselling-table-type {\n  display: flex;\n\n  &-icon {\n    background: var(--black2);\n    width: 2.5rem;\n    min-width: 2.5rem;\n    height: 2.5rem;\n    border-radius: .5rem;\n    object-fit: cover;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &-image {\n    width: 2.5rem;\n    min-width: 2.5rem;\n    height: 2.5rem;\n    border-radius: .5rem;\n    object-fit: cover;\n  }\n\n  &-date {\n    font-size: 12px;\n    color: var(--black4);\n  }\n\n  &-title {\n    display: flex;\n    justify-content: space-around;\n    flex-direction: column;\n    font-size: 14px;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
